import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, lastValueFrom } from 'rxjs';
import { jsonParse } from 'src/app/helper/class/utilityHelper';
import { AuthService } from 'src/app/helper/service/auth.service';
import { environment } from 'src/environments/environment';
import { io } from 'socket.io-client';

interface socketChanges {
  data: any,
  type: 'CALL_TOKEN' | 'NEW_TOKEN' | 'UPDATE_TOKEN' | 'NEW_MESSAGE' | 'MASTER_UPDATE' | 'COMPLETE_VISIT',
  message?: string
}

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  connectionStatus: boolean = false;
  private socket;
  SOCKET_URL = 'http://localhost:3000';
  socketEvent: Subject<socketChanges> = new Subject<socketChanges>();
  constructor(private auth: AuthService, private http: HttpClient) { }
  setsocketEvent(d: socketChanges) {
    this.socketEvent.next(d);
  }
  socketInitiationLoading = false;
  initSocket() {
    if (this.socketInitiationLoading) {
      return;
    }
    this.socketInitiationLoading = true;
    this.socket = io(this.SOCKET_URL, {
      rejectUnauthorized: false,
      withCredentials: true,
      secure: true
    });
    this.socket.on('recMessage', (data: any) => {
      const s: any = jsonParse(data);
      const d = jsonParse(data);
      console.log('on message', d)
      if (d.appId) {
        this.setsocketEvent(d)
      }
    });
    // const port = this.auth.currentSettingValue.socketPort
    // // this.socket = new WebSocket(`${environment.socketUrl}:${port}`);
    // this.socket = new WebSocket('wss://demo.piesocket.com/v3/channel_123?api_key=VCXCEuvhGcBDP7XhiJJUDvR1e1D3eiVjgZ9VRiaV&notify_self');
    // if (this.socket) {
    //   this.socket.onerror = this.onError.bind(this);
    //   this.socket.onopen = this.onOpen.bind(this);
    //   this.socket.onmessage = this.onMessage.bind(this);
    //   this.socket.onclose = this.onClose.bind(this);
    // }
    this.socketInitiationLoading = false;
  }
  onClose(event) {
    console.log('socket on close ', event)
    if (!this.socketInitiationLoading)
      this.restart()
    this.connectionStatus = false;
  }
  onOpen() {
    this.connectionStatus = true;
  }

  onError(event) {
    this.connectionStatus = false;
    //call initSocket after 
  }
  startServerLoading: boolean = false;
  restart() {
    if (!this.startServerLoading) {
      this.startServerLoading = true;
      lastValueFrom(this.http.get(`/initSocket`)).then(res => {
        //recall
        this.initSocket()
      }).finally(() => this.startServerLoading = false)
    }
  }
  onMessage(event) {
    //decode json
    const s: any = jsonParse(event);
    const d = jsonParse(event.data);
    console.log('on message', d)
    if (d.appId) {
      this.setsocketEvent(d)
    }
  }

  public sendMessage(type: 'CALL_TOKEN' | 'NEW_TOKEN' | 'UPDATE_TOKEN' | 'NEW_MESSAGE' | 'MASTER_UPDATE' | 'COMPLETE_VISIT', data: any, message = ''): void {
    // this.socket.emit('sendMessage', message);
    console.log('send message', { appId: environment.appId, type, data, message })
    this.socket.send(JSON.stringify({ appId: environment.appId, type, data, message }));
  }

  // public onMessage(): Observable<any> {
  //   return new Observable<any>(observer => {

  //     //observer.next(data)

  //   });
  // }

  public onEvent(event: Event): Observable<any> {
    return new Observable<Event>(observer => {
      this.socket.on(event, () => observer.next());
    });
  }
}